function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _create_super(Derived) {
    var hasNativeReflectConstruct = _is_native_reflect_construct();
    return function _createSuperInternal() {
        var Super = _get_prototype_of(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _get_prototype_of(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possible_constructor_return(this, result);
    };
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { openModal } from "@common/actions";
import { LOCK_PERIODS } from "@common/constants";
import { changeWebSetting } from "@common/utils/helpers";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import { isEqual } from "lodash";
import React from "react";
import { connect } from "react-redux";
var EditTimeLock = /*#__PURE__*/ function(_React_PureComponent) {
    "use strict";
    _inherits(EditTimeLock, _React_PureComponent);
    var _super = _create_super(EditTimeLock);
    function EditTimeLock(props) {
        _class_call_check(this, EditTimeLock);
        var _this;
        _this = _super.call(this, props);
        _define_property(_assert_this_initialized(_this), "renderAlwaysLockedSetting", function() {
            var i18n = _this.props.i18n;
            return /*#__PURE__*/ _jsxs("div", {
                className: "item-wrapper border-wrapper",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "toggle-switch",
                        children: /*#__PURE__*/ _jsxs("label", {
                            className: "toggle-switch-switch",
                            tabIndex: "0",
                            children: [
                                /*#__PURE__*/ _jsx("input", {
                                    ref: function(ref) {
                                        return _this.alphabeticalFilterRef = ref;
                                    },
                                    type: "checkbox",
                                    tabIndex: "-1",
                                    onChange: function(event) {
                                        return _this.handleChangeLockPeriod(event.target.checked ? LOCK_PERIODS.ALWAYS_LOCK : _this.defaultLockPeriod.value);
                                    },
                                    checked: _this.getAlwaysLock()
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "toggle-switch-slider"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("span", {
                        children: i18n.settings.alwaysLock
                    })
                ]
            });
        });
        _define_property(_assert_this_initialized(_this), "getPeriodText", function(lockPeriod) {
            return "".concat(lockPeriod.minutes, " ").concat(!lockPeriod.rawValue ? _this.props.i18n.settings.minutes : "");
        });
        _define_property(_assert_this_initialized(_this), "getAlwaysLock", function() {
            return _this.state.profileSettings.web_settings.lockPeriod === LOCK_PERIODS.ALWAYS_LOCK;
        });
        _define_property(_assert_this_initialized(_this), "handleChangeLockPeriod", function(value) {
            // Force clear timeToLockChannels
            var profileSettings = changeWebSetting(_this.state.profileSettings, {
                lockPeriod: value,
                timeToLockChannels: null
            });
            var onChangeHandler = function() {
                _this.props.onChangeHandler && _this.props.onChangeHandler(_this.state.profileSettings);
            };
            _this.setState({
                profileSettings: profileSettings
            }, onChangeHandler);
        });
        _define_property(_assert_this_initialized(_this), "renderPeriodSetting", function() {
            var i18n = _this.props.i18n;
            var alwaysLock = _this.getAlwaysLock();
            var lockPeriods = _this.lockPeriods.filter(function(e) {
                return !alwaysLock ? e.id !== -1 : true;
            });
            var periods = lockPeriods.map(function(period) {
                return /*#__PURE__*/ _jsx(MenuItem, {
                    value: period.value,
                    className: "ux-select-option",
                    classes: {
                        selected: "ux-select-option-selected"
                    },
                    children: _this.getPeriodText(period)
                }, period.id);
            });
            var period = lockPeriods.find(function(e) {
                return e.value === _this.state.profileSettings.web_settings.lockPeriod;
            });
            var currentPeriod = period || _this.defaultLockPeriod;
            return /*#__PURE__*/ _jsxs("div", {
                className: "item-wrapper ".concat(alwaysLock ? "alwaysLock" : ""),
                style: {
                    opacity: alwaysLock ? 0.5 : 1
                },
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        children: "".concat(i18n.settings.period, ": ")
                    }),
                    /*#__PURE__*/ _jsx(Select, {
                        disabled: alwaysLock,
                        value: alwaysLock ? _this.lockPeriods.find(function(e) {
                            return e.id === -1;
                        }).value : currentPeriod.value,
                        onChange: function(event) {
                            return _this.handleChangeLockPeriod(event.target.value);
                        },
                        displayEmpty: true,
                        name: "period",
                        className: "parental-control-select parental-control-title",
                        children: periods
                    })
                ]
            });
        });
        _this.lockPeriods = [
            {
                id: -1,
                value: 0,
                minutes: "Веднага",
                rawValue: true
            },
            {
                id: "2",
                value: 5 * 60 * 1000,
                minutes: "5"
            },
            {
                id: "3",
                value: 10 * 60 * 1000,
                minutes: "10"
            },
            {
                id: "4",
                value: 20 * 60 * 1000,
                minutes: "20"
            },
            {
                id: "5",
                value: 30 * 60 * 1000,
                minutes: "30"
            },
            {
                id: "6",
                value: 60 * 60 * 1000,
                minutes: "60"
            },
            {
                id: "7",
                value: LOCK_PERIODS.SESSION_LOCK,
                minutes: _this.props.i18n.settings.untilTheSessionEnd,
                rawValue: true
            }
        ];
        _this.defaultLockPeriod = _this.lockPeriods.find(function(e) {
            return e.minutes === "5";
        });
        _this.state = {
            profileSettings: _this.props.profileSettings
        };
        return _this;
    }
    _create_class(EditTimeLock, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (!isEqual(prevProps.profileSettings, this.props.profileSettings)) {
                    this.setState({
                        profileSettings: this.props.profileSettings
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var i18n = this.props.i18n;
                return /*#__PURE__*/ _jsxs("div", {
                    className: "edit-information-wrapper light edit-information-margin",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "head",
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "icon-2 icon-settings-font-lock icon"
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: "text",
                                    children: i18n.settings.timeToUnlockAChannel
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "details",
                            children: [
                                this.renderAlwaysLockedSetting(),
                                this.renderPeriodSetting()
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return EditTimeLock;
}(React.PureComponent);
var mapStateToProps = function(param) {
    var i18n = param.i18n, profileSettings = param.profileSettings;
    return {
        i18n: i18n,
        profileSettings: profileSettings
    };
};
export default connect(mapStateToProps, {
    openModal: openModal
})(EditTimeLock);
